module.exports = __webpack_public_path__ + "static/images/qq-1.18dd0e2.png";